import tinycolor from 'tinycolor2';

var getHSLColor = function getHSLColor(color) {
  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;
  var l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

  var _tinycolor$toHsl = tinycolor(color).toHsl(),
      h = _tinycolor$toHsl.h;

  return tinycolor("hsl(".concat(h, ", ").concat(s, ", ").concat(l, ")")).toHexString();
};

export default getHSLColor;